import * as React from 'react';
import { useMemo } from 'react';

import { Alert } from 'components/bootstrap';
import { DocumentationLink } from 'components/support';
import DocsHelper from 'util/DocsHelper';
import DataLakeWidgetConfig from 'data-lake/logic/DataLakeWidgetConfig';

import PreviewLayoutContext from '../../../contexts/PreviewLayoutContext';

const WidgetEditInfo = () => (
  <Alert bsStyle="info">
    The field select contains options for fields which exist as columns in the data lake. It is possible to type in and
    add any custom field name, by clicking on the <i>Create &quot;custom_field&quot;</i> option. See{' '}
    <DocumentationLink page={DocsHelper.PAGES.DATA_LAKE} text="documentation" />.
  </Alert>
);

const PreviewLayoutProvider = ({ children }: React.PropsWithChildren) => {
  const contextValue = useMemo(
    () => ({
      widgetEdit: {
        formInfo: <WidgetEditInfo />,
        showFieldSelect: true,
        fieldsCreationAllowed: true,
      },
      defaultFields: DataLakeWidgetConfig.defaultFields,
    }),
    [],
  );

  return <PreviewLayoutContext.Provider value={contextValue}>{children}</PreviewLayoutContext.Provider>;
};

export default PreviewLayoutProvider;
